<template>
  <v-card>
    <v-card-title class="project">
      <div class="white--text headline">
        <span>Project's Locations</span>
      </div>
    </v-card-title>
    <v-card-text>
      <v-toolbar flat color="white">
        <div class="text-xs-center">
        </div>
        <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            align="center"
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>

      <v-data-table
        :search="search"
        :headers="headers"
        :items="projectLocation"
        class="elevation-1"
      >
      <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template v-if="totalData > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.project_id }}</td>
          <td>{{ props.item.division_name }}</td>
          <td>{{ props.item.district_name }}</td>
          <td>{{ props.item.upazila_name }}</td>
          <td>{{ props.item.area }}</td>
          <td>{{ props.item.zip_code }}</td>
          <td>{{ props.item.latitude }}</td>
          <td>{{ props.item.longitude }}</td>
          <td>{{ props.item.address }}</td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            No Data Here
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>      
</template>
  
  <script>
  import axios from "axios";
  import {ROOT_URL} from '@/api/connectingUrls'; 

   export default {
      props:{
        projectId: Number,
      },
      data: () => ({
        apiUrl: 'get-loc-preview',
        search: '',
        error:'',
        errorMsg:'',
        projectLocation:[],
        totalData:0,
        headers: [
          { text: "Id", align: "left", value: "id" },
          { text: "Project Id", align: "left", value: "project_id" },
          { text: "Division", align: "left", value: "division_name" },
          { text: "District", align: "left", value: "district_name" },
          { text: "Upazila", align: "left", value: "upazila_name" },
          { text: "Area",sortable: false, value: "area" },
          { text: "Zip Code",sortable: false, value: "zip_code" },
          { text: "Latitude",sortable: false, value: "latitude" },
          { text: "Longitude",sortable: false, value: "longtude" },
          { text: "Address", value: "address" },
        ]
      }),

      created () {  
        this.initialize()
      },
  
      methods: {
        initialize() {
          this.getLocationData(this.projectId)
        },
        async getLocationData(itemId) {
            try {
                const token = window.localStorage.getItem('datadash_token');
                if(token != null){ 
                    return await axios.get(`${ROOT_URL}/${this.apiUrl}/${itemId}`,{
                    headers:{
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    // console.log(response);
                    if(response.data.error==0){
                        this.projectLocation=response.data.data.importLoc
                        this.totalData=response.data.data.totImportedLoc
                    }else{
                        this.error=response.data.error
                        this.errorMsg=response.data.errorMsg
                    }
                })
                }}catch (error) {
                    // console.log(error);
                }
        },
      }
    }
  </script>
  
  <style scoped>
  .icon {
    background: #ff2e2e;
    color: aliceblue;
    cursor: pointer;
    border-radius: none;
    margin: 10px;
  }
  .button {
    font-size: 16px;
    background: #ff2e2e;
    padding: 0.4rem 1.3rem;
    text-align: center;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    margin: 10px;
    color: white;
  }
  .delete {
    color: #3F51B5;
    cursor: pointer;
  }
  span{
    width: 20px;
    cursor: pointer;
  }
  .no-upercase {
    text-transform: unset !important;
  }
  .text_color{
      color: white;
  }
  .project{ 
    background: #ff2e2e;  
  }
  
  </style>
  